export const USER_LOGGEDIN = "USER_LOGGEDIN";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGOUT = "LOGOUT";
export const SET_LOADING = "SET_LOADING";
export const END_LOADING = "END_LOADING";
